import { Children, cloneElement, isValidElement } from 'react';
import { ComponentWithAs, useMultiStyleConfig } from '@chakra-ui/react';

import Step from './components/Step';
import { COMPONENT_NAME, StylesProvider } from './context';

export interface TimelineParts {
  Step: typeof Step;
}

type TimelineType = ComponentWithAs<'div'> & TimelineParts;

const Timeline: TimelineType = ({ children }) => {
  const childrenCount = Children.count(children);
  const styles = useMultiStyleConfig(COMPONENT_NAME);

  return (
    <StylesProvider value={styles}>
      {Children.map(children, (child, i) => {
        if (!isValidElement(child)) {
          return null;
        }

        return cloneElement(child, {
          isLast: i === childrenCount - 1,
        } as never);
      })}
    </StylesProvider>
  );
};

Timeline.Step = Step;

export default Timeline;
